<template>
  <el-dialog
    :custom-class="$style.dialog"
    title="修改转移码"
    :visible="true"
    @close="$emit('close')"
  >
    <Loading :loading="loading" text="">
      <Item title="转入的域名：">{{ info.domainName || "" }}</Item>

      <Item title="域名转移码：">
        <el-input v-model.trim="code" placeholder="请填写" />
      </Item>

      <Item>
        <Button type="primary" @click="confirm">确认</Button>
        <Button type="primary2" @click="cancel">取消</Button>
      </Item>
    </Loading>
  </el-dialog>
</template>

<script>
import { updateTransferCode } from "@server";

// 修改转移码
export default {
  name: "ChangeCodePopup",
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      loading: false,
      code: "",
    };
  },
  methods: {
    async confirm() {
      if (!this.code) {
        this.$message({ message: "请输入域名转移码!", type: "warning" });
        return;
      }

      this.loading = true;
      const data = {
        id: this.info.id,
        trCode: this.code,
      };
      const res = await updateTransferCode(data);

      if (res.code == 200) {
        this.$message({ message: "修改成功!", type: "warning" });
        this.$emit("success");
        this.cancel();
      }
      this.loading = false;
    },
    cancel() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" module scoped>
::v-deep .dialog {
  width: 500px;

  :global {
    .gl-item {
      margin: 0 0 rem(40) 100px;
    }

    .gl-button {
      margin-right: rem(50);
    }

    .el-input {
      width: 200px;
    }
  }
}
</style>
